import { Pin, PinType, pinInteractiveTypes } from '@lessonup/pins-shared';
import { isNil, some } from 'lodash';

// TODO: this should be moved to the pins-shared package
export class PinUtils {
  public static isInteractive = (pin: Pin | undefined) =>
    !isNil(pin) && some(pinInteractiveTypes, (t) => t == pin.type);

  public static typeIsInteractive = (pinType: PinType | undefined) =>
    !!pinType && (pinInteractiveTypes as readonly PinType[]).includes(pinType);
}
